module.exports = __webpack_public_path__ + "img/sparkle-disabled.3c297ac1.svg";